<template>
  <wrapper-page ref="wrapper">
    <div class="">UNDER CONSTRUCTION</div>
  </wrapper-page>
</template>

<script>
import WrapperPage from "@/components/layout/WrapperPage.vue";

export default {
  name: "ResourcesIndex",
  components: { WrapperPage },
  data() {
    return {};
  },
  methods: {},
};
</script>
